const actionBtn = {
  textTransform: 'none',
  marginTop: '2%',
  marginLeft: '10px',
  float: 'right'
};

export { actionBtn }
